import TableRowAddAboveIcon from '@atlaskit/icon/core/table-row-add-above';
import TableRowAddBelowIcon from '@atlaskit/icon/core/table-row-add-below';
import { SHORTCUTS } from '@databases/keyboard-shortcuts';
import React from 'react';
import { useIntl } from 'react-intl-next';

import { type Trigger, type Action, ActionPopup } from '../ActionPopup';
import { type PositionType } from '../actions/entries/select-entries-actions';
import { messages } from '../messages';

type AddNewEntryTypes = {
  handleInsertEntries: (position: PositionType) => void;
};

export const AddNewEntry = ({ handleInsertEntries }: AddNewEntryTypes) => {
  const { formatMessage } = useIntl();
  const actions: Action[] = [
    {
      type: 'add-above',
      message: formatMessage(messages['action-bar.single-entry-add-entry-above-action']),
      icon: (
        <TableRowAddAboveIcon
          label={formatMessage(
            messages['action-bar.single-entry-add-entry-above-action']
          )}
          size="medium"
        />
      ),
      onClick: () => handleInsertEntries('before'),
      shouldRender: true,
      shortcut: SHORTCUTS.ADD_ENTRY_ABOVE
    },
    {
      type: 'add-below',
      message: formatMessage(messages['action-bar.single-entry-add-entry-below-action']),
      icon: (
        <TableRowAddBelowIcon
          label={formatMessage(
            messages['action-bar.single-entry-add-entry-below-action']
          )}
          size="medium"
        />
      ),
      onClick: () => handleInsertEntries('after'),
      shouldRender: true,
      shortcut: SHORTCUTS.ADD_ENTRY_BELOW
    }
  ];
  const trigger: Trigger = {
    type: 'add',
    message: formatMessage(messages['action-bar.single-entry-add-button']),
    icon: (
      <TableRowAddBelowIcon
        label={formatMessage(messages['action-bar.single-entry-add-button'])}
        size="medium"
      />
    ),
    selectionMode: 'entry'
  };
  return <ActionPopup actions={actions} trigger={trigger} />;
};
